export default __webpack_public_path__ + "static/media/tg_icon.0d701056.svg";